import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 21 20",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m14.211 2.703 4.783 4.59c.469.45.732 1.06.732 1.697s-.263 1.247-.732 1.697l-5.405 5.19c-1.407 1.35-3.315 2.108-5.304 2.108-1.99 0-3.897-.758-5.303-2.109l-1.25-1.2a2.333 2.333 0 0 1 0-3.393l8.944-8.58a2.574 2.574 0 0 1 3.535 0Z",
		fill: "#000",
		fillRule: "evenodd",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2021%2020%22%3E%3Cpath%20d%3D%22m14.211%202.703%204.783%204.59c.469.45.732%201.06.732%201.697s-.263%201.247-.732%201.697l-5.405%205.19c-1.407%201.35-3.315%202.108-5.304%202.108-1.99%200-3.897-.758-5.303-2.109l-1.25-1.2a2.333%202.333%200%200%201%200-3.393l8.944-8.58a2.574%202.574%200%200%201%203.535%200Z%22%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23fff%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
